import { MeetingAvailability } from 'modules/calendar/constants/calendarMeetingTemplateSchema';
import { format } from 'date-fns';

export const convertAvailabilityToSchema = (
  days: Array<{ day: number; availability?: MeetingAvailability }>
) => {
  return days.reduce((acc, { day, availability }) => {
    if (!availability || availability.length === 0) {
      return acc; // Skip days with no availability
    }

    acc[day] = availability
      .filter((timeRange) => timeRange.length === 2) // Ensure valid [start, end] pairs
      .map(([start, end]) => ({
        start: format(new Date(start), 'HH:mm'),
        end: format(new Date(end), 'HH:mm')
      }));

    return acc;
  }, {} as Record<number, { start: string; end: string }[]>); // Explicitly define the accumulator type
};
